import { CgArrowLongRight } from "react-icons/cg";

const HomeTwoChannelPartners = () => {
  return (
    <>
      <section className="channel-partners__area pt-115 pb-120 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6">
              <div className="channel-partners__content-left">
                <div className="section__title section__title-h2 mb-25">
                  <span>AUTHORIZED PARTNERS</span>
                  <h2>
                    Our network of trusted <br /> channel partners
                  </h2>
                </div>
                <p>
                  We collaborate with industry-leading partners to deliver comprehensive 
                  solutions that address your business needs. Our authorized partners 
                  maintain the highest standards of quality and expertise.
                </p>
                {/* <Link to="/partners" className="z-btn">
                  View all partners
                  <i>
                    <CgArrowLongRight />
                  </i>
                </Link> */}
              </div>
            </div>
            <div className="col-xl-6 col-lg-6">
              <div
                className="channel-partners__featured text-center"
                style={{
                  padding: '45px 40px',
                  background: 'rgba(255, 255, 255, 0.85)',
                  backdropFilter: 'blur(16px)',
                  WebkitBackdropFilter: 'blur(16px)',
                  borderRadius: '24px',
                  border: '1px solid rgba(255, 255, 255, 0.18)',
                  boxShadow: '0 4px 16px 0 rgba(31, 38, 135, 0.08)',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                }}
              >
                <div className="featured-partner__logo mb-4">
                  {/* This is a placeholder for the partner logo */}
                  {/* Replace "/assets/img/partners/partner-logo.png" with your actual logo path */}
                  <img
                    src="/assets/img/Spectrum_Auth_Channel_Partner.png"
                    alt="Authorized Channel Partner"
                    className="img-fluid"
                    style={{ maxHeight: "120px" }}
                  />
                </div>
                {/* <h3 className="featured-partner__title mb-3">Official Authorized Channel Partner</h3> */}
                <p
                  className="featured-partner__text mb-4"
                  style={{
                    fontSize: '17px',
                    lineHeight: '1.8',
                    opacity: '0.95'
                  }}
                >
                  Our premier partner delivers exceptional service and expertise
                  in implementing our solutions for businesses of all sizes.
                </p>
                <a
                  href="https://www.spectrum.com/business/about"
                  target="_blank"
                  className="z-btn z-btn-border"
                  style={{
                    padding: '14px 35px',
                    borderRadius: '12px',
                    fontSize: '16px',
                    fontWeight: '600',
                    letterSpacing: '0.5px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  Learn about Spectrum
                  <i>
                    <CgArrowLongRight />
                  </i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeTwoChannelPartners;